import styled, { css } from 'styled-components';

import { Flexer } from '@ontruck/orc';

const brackgroundStyles = ({ background, theme }) => css`
  background: ${`var(--${background})` || '#fff'};
`;

const SectionStyled = styled(Flexer.Child)`
  ${brackgroundStyles}
`;

export default SectionStyled;
